import { render, staticRenderFns } from "./DefiFTrade.vue?vue&type=template&id=68a2a596&"
import script from "./DefiFTrade.vue?vue&type=script&lang=js&"
export * from "./DefiFTrade.vue?vue&type=script&lang=js&"
import style0 from "./DefiFTrade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports